<template>
  <div id="checkbox">
    <label v-if="label !== ''" :for="name">
      {{ label }}
    </label>
    <div class="form-check" :class="{ 'form-switch': type === 'switch' }">
      <input
        :id="`${name}-${index || ''}`"
        :value="modelValue"
        :checked="modelValue"
        type="checkbox"
        :name="name"
        class="form-check-input mt-2"
        :disabled="isDisabled"
        @input="setInputValue"
      />
      <label :for="name" class="form-check-label">
        {{ text }}
      </label>
    </div>
    <error-message-new :index="index" :errors="errors" :fieldName="name" />
  </div>
</template>

<script>
import { handleFieldState } from "@/helper/fieldStateHandler";

export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    index: {
      type: Number,
      default: null,
    },
    name: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: "",
    },
    inline: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: [String, Number, Boolean],
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    isDisable: {
      type: Boolean,
      default: false,
    },
    parent: {
      type: String,
      default: null,
    },
    showError: {
      type: Boolean,
      default: true,
    },
    errors: {
      type: Array,
    },
    logic: {
      type: Object,
      default: () => ({}),
    },
    content: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    localValue: null,
  }),
  methods: {
    handleFieldState,
    setInputValue(event) {
      this.$emit('inputEvent', event)
    },
  },
};
</script>

<style></style>
